var youbora = require('youboralib')
var manifest = require('../../manifest.json')

var AdsAdapter = youbora.Adapter.extend({
  /** Override to return current plugin version */
  getVersion: function () {
    return manifest.version + '-Bitmovin8-ads'
  },

  /** Override to return current playhead of the video */
  getPlayhead: function () {
    return this.player.getCurrentTime()
  },

  getTitle: function () {
    return this.title
  },

  /** Override to return video duration */
  getDuration: function () {
    return this.duration
  },

  /** Override to return resource URL. */
  getResource: function () {
    return this.src
  },

  /** Override to return rendition */
  getRendition: function () {
    return youbora.Util.buildRenditionString(this.width, this.height, this.bitrate)
  },

  getBitrate: function () {
    return this.bitrate * 1000
  },

  // getGivenBreaks: function () { },
  // getBreaksTime: function () { },
  // getGivenAds: function () { },

  getAudioEnabled: function () {
    return this.player.getVolume() > 0 && !this.player.isMuted()
  },

  getIsSkippable: function () {
    return this.skippable
  },

  getIsFullscreen: function () {
    return this.player.getViewMode() === 'fullscreen'
  },

  getIsVisible: function () {
    return youbora.Util.calculateAdViewability(this.player.getVideoElement())
  },

  getCreativeId: function () {
    return this.creativeId
  },

  /** Override to return current ad position (only ads) */
  getPosition: function () {
    return this.position
  },

  /** Register listeners to this.player. */
  registerListeners: function () {
    var events = this.player.exports.PlayerEvent

    // Enable playhead monitor (buffer = true, seek = false)
    this.monitorPlayhead(true, true)

    // References
    this.references = []
    this.references[events.AdBreakStarted] = this.breakStartListener.bind(this)
    this.references[events.AdBreakFinished] = this.breakEndListener.bind(this)
    this.references[events.AdStarted] = this.adStartListener.bind(this)
    this.references[events.AdFinished] = this.adEndListener.bind(this)
    this.references[events.AdQuartile] = this.quartileListener.bind(this)
    this.references[events.AdSkipped] = this.skipListener.bind(this)
    this.references[events.AdClicked] = this.clickListener.bind(this)
    this.references[events.AdError] = this.errorListener.bind(this)

    // Register listeners
    for (var key in this.references) {
      this.player.on(key, this.references[key])
    }
  },

  /** Unregister listeners to this.player. */
  unregisterListeners: function () {
    // Disable playhead monitoring
    if (this.monitor) this.monitor.stop()
    // unregister listeners
    if (this.player && this.player && this.references) {
      for (var key in this.references) {
        this.player.off(key, this.references[key])
      }
      this.references = []
    }
  },

  breakStartListener: function (e) {
    this.plugin.fireInit()
    this.plugin.getAdapter().firePause()
    var position = e.adBreak.position
    var adapterInst = this.plugin.getAdapter()
    if (position === 'pre') {
      this.position = youbora.Constants.AdPosition.Preroll
    } else if (adapterInst.getDuration() !== 0 && (adapterInst.getPlayhead() || position) > adapterInst.getDuration() - 1) {
      this.position = youbora.Constants.AdPosition.Postroll
    } else {
      this.position = youbora.Constants.AdPosition.Midroll
    }
  },

  breakEndListener: function (e) {
    this.fireBreakStop()
    if (this.plugin.requestBuilder.lastSent.adPosition !== youbora.Constants.AdPosition.Postroll) {
      this.plugin.getAdapter().fireResume()
    } else {
      this.plugin.fireStop()
    }
  },

  adStartListener: function (e) {
    this.title = e.ad.data.adTitle
    this.bitrate = e.ad.data.bitrate
    this.creativeId = e.ad.data.creative.id
    this.src = e.ad.mediaFileUrl
    this.height = e.ad.height
    this.width = e.ad.width
    this.skippable = e.ad.skippable
    this.duration = e.ad.duration
    this.counter = 0
    this.fireStart()
    this.fireJoin()
  },

  adEndListener: function (e) {
    this.fireStop()
    if (this.plugin.requestBuilder.lastSent.adPosition === youbora.Constants.AdPosition.Postroll) this.plugin.fireStop()
  },

  quartileListener: function (e) {
    var position = 1
    switch (e.quartile) {
      case 'midpoint':
        position = 2
        break
      case 'thirdQuartile':
        position = 3
    }
    this.fireQuartile(position)
  },

  skipListener: function (e) {
    this.fireSkip()
    if (this.plugin.requestBuilder.lastSent.adPosition === youbora.Constants.AdPosition.Postroll) this.plugin.fireStop()
  },

  clickListener: function (e) {
    this.fireClick(e.clickThroughUrl)
  },

  errorListener: function (e) {
    var errObj = e.data ? e.data : e
    this.fireError(errObj.code, errObj.message)
  }
})

module.exports = AdsAdapter
